<template>
  <div />
</template>
<script>
import "leaflet-canvaslayer-field/dist/leaflet.canvaslayer.field.js";
import chroma from "chroma";

export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    palette: {
      type: String,
      required: false,
      default: "RdYlGn" // Colors definitions from http://colorbrewer2.org.
    },
    title: {
      type: String,
      required: true
    },
    range: {
      type: Array,
      required: false,
      default() {
        return [0, 100];
      }
    }
  },
  data() {
    return {
      colorScale: chroma.scale(this.palette).domain(this.range),
      legend: {},
      map: this.$parent.map
    };
  },
  watch: {
    title() {
      this.removeLegend(); // refresh legend on layer change
      if (this.title !== "" && this.active) {
        this.loadLegend();
      }
    }
  },
  mounted() {
    if (this.active) {
      this.loadLegend();
    }
  },
  destroyed() {
    this.removeLegend();
  },
  methods: {
    loadLegend() {
      this.legend = L.control.colorBar(this.colorScale, this.range, {
        title: this.title,
        ...this.config
      });
      this.legend.addTo(this.map);
    },
    removeLegend() {
      if (Object.keys(this.legend).length > 0) {
        this.map.removeControl(this.legend);
      }
    }
  }
};
</script>
<style scoped></style>
